export const formatDate = (date: Date, locale = 'fr-FR') => {
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Paris',
  }).format(date);
};

export const formatDateWithTime = (date: Date, locale = 'fr-FR') => {
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Paris',
  }).format(date);
};

/** Date and time read in `timeZone`, naming it: "17/11/2026 00:00 (Europe/Paris)". */
export const formatZonedDateTime = (date: Date, timeZone: string, locale = 'fr-FR') => {
  const formatted = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone,
  }).format(date);
  return `${formatted} (${timeZone})`;
};

export const getLocaleMonth = (date: Date, locale: string = 'fr-FR') => {
  return new Intl.DateTimeFormat(locale, {
    month: 'long',
    year: 'numeric',
    timeZone: 'Europe/Paris',
  }).format(date);
};
